import { useSearchStore } from "~/stores/search";
import { mapStores } from 'pinia';

const searchModes = {
    ROOT: '1',
    WORD: '2',
    WORD_ENTRY: '3',
}

export default {
    setup() {
        const { t } = useI18n();
        // ... other setup code
        return { t, /* ... other returned values */ };
    },
    name: 'SearchAutocomplete',
    props: ['searchText', 'filterId', 'mode', 'lbl', 'surah', 'propername', 'search', 'subject', 'pHolder'],
    data() {
        return {
            searchEntry: this.searchText,
            searchResults: [],
            showSearchResults: false,
            arrowCounter: -1,
            isLoading: false,
            searchModeId: this.filterId,
            showSearchMode: this.mode === 'vocabulary',
            lbl: this.lbl
        }
    },
    computed: {
        ...mapStores(useSearchStore),
    },
    mounted() {
        document.addEventListener('click', this.handleClickOutside)
    },
    destroyed() {
        document.removeEventListener('click', this.handleClickOutside)
    },
    methods: {
        handleClickOutside(event) {
            if (!this.$el.contains(event.target)) {
                this.showSearchResults = false;
                this.arrowCounter = -1;
            }
            // else {
            //     this.showSearchResults = true;
            // }
        },

        onArrowUp() {
            if (this.arrowCounter > 0) {
                this.arrowCounter = this.arrowCounter - 1;
            }
        },
        onArrowDown() {
            if (this.arrowCounter < this.searchResults.length - 1) {
                this.arrowCounter = this.arrowCounter + 1;
            }
        },

        onSubmit() {
            this.showSearchResults = false;
            if (!this.searchEntry && this.arrowCounter === -1) {
                return;
            }

            if (this.mode === 'vocabulary') {
                if (this.arrowCounter === -1) {
                    if (this.mode === 'vocabulary') {
                        this.setResult({
                            wordId: 0,
                            searchModeId: this.searchModeId,
                            text: $.trim(this.searchEntry),
                            type: 'SearchBoxEnter'
                        })
                        return
                    } else {
                        this.arrowCounter = 1
                    }
                }
                selectedSearchItem.type = 'AutoCompleteSelected'
            }
            this.searchResults === undefined ? this.searchResults = [] : {}; // QUICK FIX
            let selectedSearchItem = this.searchResults[this.arrowCounter] || { text: this.searchEntry, isEnterPressed: true };
            this.arrowCounter = -1;
            this.setResult(selectedSearchItem)
        },

        // onEnterKeyPressed() {
        //     this.$emit('onEnterKeyPressed', this.searchEntry)
        // },

        setResult(result) {
            // this.searchEntry = $.trim(result.text);
            this.showSearchResults = false;

            result.selected = true;

            if (this.mode === 'vocabulary') {
                let newSelectedSearchItem = {
                    wordId: result.wordId,
                    entryId: result.entryId,
                    searchMode: this.searchModeId,
                    text: result.text,
                    type: result.type ?? 'AutoCompleteSelected'
                }

                this.$emit('onSelectSearchItem', newSelectedSearchItem)
            } else if (this.mode === 'quran' || this.surah || this.propername || this.search || this.subject) {
                this.$emit('onSelectSearchItem', result)
            }
        },

        async onChangeSearchQuery() {
            this.showSearchResults = true

            if (this.mode === 'vocabulary') {
                const params = {
                    withErab: true,
                    pageSize: 7,
                    pageNum: 1,
                    selectedId: 0,
                    enSelectedId: 0,
                    searchText: $.trim(this.searchEntry) ?? '',
                    filterId: this.searchModeId
                }

                const data = await this.searchStore.vocabularyAutoComplete(params)

                if (data?.length)
                    this.searchResults = data?.map((vocab) => {
                        let result = {
                            wordId: vocab.WordId,
                            entryId: vocab.EntryId,
                            RootTitle: vocab.RootTitle,
                            WordTitle: vocab.WordTitle,
                            EntryTitle: vocab.EntryTitle
                        }

                        switch (this.searchModeId) {
                            case searchModes.ROOT:
                                result.text = vocab.RootTitle
                                return result

                            case searchModes.WORD:
                                result.text = vocab.WordTitle
                                result.textWithoutErab = vocab.WordTitleSample
                                return result

                            case searchModes.WORD_ENTRY:
                                result.text = vocab.EntryTitle
                                return result
                        }
                    })
            } else {
                const params = {
                    searchText: this.searchEntry,
                    pageNumber: 1,
                    pageSize: (this.surah) ? 114 : (this.propername ? 2000 : 10),
                    searchType: this.search?.searchType || 0,
                    source: this.search?.source || ((this.surah) ? 'surah' : ((this.propername) ? 'propername' : (this.subject ? 'subject' : 'quran'))),
                    quranDomain: "text",
                    stem: this.search?.stem === false ? false : true,
                    synonym: this.search?.synonym === false ? false : true,
                    root: this.search?.root === false ? false : true,
                    type: "auto"
                }
                this.isLoading = true;
                let data = await this.searchStore.quranAutoComplete(params)
                this.isLoading = false;
                if (data?.length)
                    if (this.surah) {
                        data = data.map((surah) => {
                            const surahData = this.surah.find(s => s.Id == surah.id);
                            let names = [surah.title, ...surahData.Names.split('،')];
                            let targetIndex = 1;
                            for (let name of names) {
                                if (name.includes(this.searchEntry)) {
                                    targetIndex = names.indexOf(name);
                                    names[names.indexOf(name)] = name.replace(this.searchEntry, `<span class="highlight">${this.searchEntry}</span>`);
                                    break;
                                }
                            }
                            return {
                                title: `${names[0]} (${names.slice(targetIndex).join('، ')} )`,
                                id: surah.id,
                            }
                        })
                    }
                this.searchResults = data
            }
        }
    },
};